import { css, keyframes, type Theme } from '@emotion/react';

const shimmer = keyframes`
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
`;

const skeletonBlock = (theme: Theme) => css`
  background: linear-gradient(
    90deg,
    ${theme.colors.gray[100]} 15%,
    ${theme.colors.gray[50]} 50%,
    ${theme.colors.gray[100]} 85%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.4s linear infinite;
`;

export const container = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: 1px solid;
  border-color: var(--skeleton-border-color);
  border-radius: 8px;
  padding: 16px;

  --skeleton-border-color: #e7eaef;
`;

export const header = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const avatarGroup = css`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const avatarSkeleton = (theme: Theme) => css`
  ${skeletonBlock(theme)};
  width: 24px;
  height: 24px;
  border-radius: 50%;
`;

export const presenterSkeleton = (theme: Theme) => css`
  ${skeletonBlock(theme)};
  width: 110px;
  height: 12px;
  border-radius: 999px;
`;

export const tagSkeleton = (theme: Theme) => css`
  ${skeletonBlock(theme)};
  width: 44px;
  height: 20px;
  border-radius: 999px;
`;

export const pictureWrapper = css`
  position: relative;
`;

export const pictureSkeleton = (theme: Theme) => css`
  ${skeletonBlock(theme)};
  width: 100%;
  height: 132px;
  border-radius: 8px;
`;

export const replayTagSkeleton = (theme: Theme) => css`
  ${skeletonBlock(theme)};
  position: absolute;
  top: 8px;
  left: 8px;
  width: 52px;
  height: 20px;
  border-radius: 999px;
`;

export const iconBadgeSkeleton = (theme: Theme) => css`
  ${skeletonBlock(theme)};
  position: absolute;
  right: 10px;
  bottom: 10px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
`;

export const content = css`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const titleSkeleton = (theme: Theme) => css`
  ${skeletonBlock(theme)};
  width: 92%;
  height: 16px;
  border-radius: 999px;
`;

export const titleSkeletonSecondary = (theme: Theme) => css`
  ${skeletonBlock(theme)};
  width: 68%;
  height: 16px;
  border-radius: 999px;
`;

export const footer = css`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 2px;
`;

export const viewsRow = css`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const viewsIconSkeleton = (theme: Theme) => css`
  ${skeletonBlock(theme)};
  width: 16px;
  height: 16px;
  border-radius: 50%;
`;

export const viewsTextSkeleton = (theme: Theme) => css`
  ${skeletonBlock(theme)};
  width: 86px;
  height: 12px;
  border-radius: 999px;
`;

export const dateSkeleton = (theme: Theme) => css`
  ${skeletonBlock(theme)};
  width: 96px;
  height: 12px;
  border-radius: 999px;
  margin-top: 4px;
`;
